
export const OPERATION_TYPE = process.env.REACT_APP_ENVIRONMENT;//"DEV"; // STAGE, PROD , DEV, TEST
export const LANDING_URL = "/dashboard";
export const BASE_TITLE = ` | ${process.env.REACT_APP_CHANNEL_CODE} `;

export const DEFAULT_LIST_PAGESIZE = 10;

export const API_SERVER = process.env.REACT_APP_API;

export const TIMEOUT_ALERT_IN_SECUNDES = 7;
export const TIMEOUT_REDIRECT_IN_SECUNDES = 7;
export const TIMEOUT_API_POST_IN_MILISECUNDES = 15000;

export const TERMS_REFRESH_INTERVAL_IN_MILISECUNDES = process.env.REACT_APP_TERMS_REFRESH_INTERVAL_IN_MINUTES * 1000 * 60;